import type { PostProfileResponse } from 'klaviyo-api';
import { AbstractClient } from './AbstractFetchClient';

export class KlaviyoClient extends AbstractClient {
  createProfile = this.payloadHandler<
    PostProfileResponse['data'],
    {
      payload: {
        email: string;
      };
    }
  >('POST', '');
}
